import { connect } from 'react-redux'
import Session from './Session.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsSessions.chartType,
    granularity: state.analyticsSessions.granularity,
    dateRange: state.analyticsSessions.dateRange,
    customDateRange: state.analyticsSessions.customDateRange,
    channelNameToFilter: state.analyticsSessions.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.sessionsChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.sessionsChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.sessionsMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.sessionsChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.sessionsChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Session)
